// extracted by mini-css-extract-plugin
export default {"buttonRow":"CreateAccount_buttonRow__n5bs4","redirectLink":"CreateAccount_redirectLink__izgHa"};